import { Injectable } from '@angular/core';
import { CreateScenarioRequest } from '../scenario-activities/scenario.service';
import { AuthService } from '../authentication/auth.service';
import { Observable } from 'rxjs/Rx';
import { ThrowStmt } from '@angular/compiler/src/output/output_ast';
//import { plainToClass } from "class-transformer"; 

@Injectable() 
export class UserSession {
    public userId: number;
    public fullName: string;
    public roles: string;
    public scenarioId: number;
    public id: number;
    public fullname:string;

    //convienence properties
    public isAdmin: boolean;
    public isRegionalManager: boolean;
    public isReadOnly: boolean;
    
    constructor(private _authService: AuthService){
        this.userId = _authService.getUserId();
        this.fullName = _authService.getFullName();
        this.roles = _authService.getRoles();
        this.isAdmin = _authService.isAdmin();
        this.isRegionalManager = _authService.isRegionalManager();
        this.isReadOnly = _authService.isReadOnly();
        this.scenarioId = 1; // default to National
    }

    public updateSessionState(){
        if(sessionStorage.getItem('user-session') !== null)
            sessionStorage.removeItem('user-session');
        
        sessionStorage.setItem('user-session', JSON.stringify(sessionStorage["token"]));
    }

    public getSession():UserSession{
        if(sessionStorage.getItem('user-session') === null)
            return null;
        
        //let uSession:UserSession = JSON.parse(sessionStorage.getItem('user-session')) as UserSession;

        let jsonObject: any = JSON.parse(sessionStorage["token"]);
        let uSession: UserSession = <UserSession>jsonObject;
        uSession.scenarioId = this.scenarioId;
        uSession.isAdmin = this._authService.isAdmin();
        uSession.isRegionalManager = this._authService.isRegionalManager();
        uSession.isReadOnly = this._authService.isReadOnly();
        //console.log("uSession.scenarioId" + uSession.scenarioId);
        return uSession;
    }

    public getUserId():number{
        let userId = this._authService.getUserId();
        return userId;
    }

    public getScenarioId():number{
        return this.scenarioId;
    }

    public hasValidSession():boolean {
        return sessionStorage.getItem('user-session') !== null;
    }
}


/** WEBPACK FOOTER **
 ** ./app/shared/user-session.ts
 **/